var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeType"},[_c('div',{staticClass:"title",style:(("margin-top:" + _vm.top + "rem;margin-bottom:" + _vm.bottom + "rem;"))},[_vm._v(_vm._s(_vm.$t(_vm.text).toUpperCase()))])])}
var staticRenderFns = []

export { render, staticRenderFns }